import React from "react";
import { Ong } from "../../../utils/entities/Ong";
import { formatRichText } from "../../../utils/formatRichText";

const Description = (props: any) => {
  const ong: Ong = props.ong;

  return <div className="descripcion">{formatRichText(ong.description)}</div>;
};

export default Description;
